import { AsideService } from '@qima-labs/app/pages/main/shared/components/aside/shared/services/aside.service';
import { AccountMenuComponent } from '@qima-labs/app/pages/main/shared/components/header/shared/components/account-menu/account-menu.component';
import { UserGuideComponent } from '@qima-labs/app/pages/main/shared/components/header/shared/components/user-guide/user-guide.component';
import { HeaderService } from '@qima-labs/app/pages/main/shared/components/header/shared/service/header.service';
import { LOCAL_IMAGES } from '@qima-labs/app/shared/constants/images.constants';
import { ERouters } from '@qima-labs/app/shared/models/enums/routers.enum';
import { DialogService } from '@qsp-ui-library/components/modal/shared/services/dialog.service';
import { TranslateMenuModule } from '@qsp-ui-library/components/translate-menu/translate-menu.module';
import { IMyWindow } from '@qsp-ui-library/interfaces/my-window.interface';
import { IUser } from '@qsp-ui-library/models/interfaces/user.interface';
import { QimaAvatarService } from '@qsp-ui-library/services/exported-services/qima-avatar/qima-avatar.service';
import { QimaButtonService } from '@qsp-ui-library/services/exported-services/qima-button/qima-button.service';
import { QimaButtonIconService } from '@qsp-ui-library/services/exported-services/qima-button-icon/qima-button-icon.service';
import { QimaDividerService } from '@qsp-ui-library/services/exported-services/qima-divider/qima-divider.service';
import { QimaIconService } from '@qsp-ui-library/services/exported-services/qima-icon/qima-icon.service';
import { QimaTooltipService } from '@qsp-ui-library/services/exported-services/qima-tooltip/qima-tooltip.service';
import { AppAuthenticationService } from '@qsp-ui-library/services/user-services/app-authentication/app-authentication.service';
import { AppUserSettingService } from '@qsp-ui-library/services/user-services/app-user-setting/app-user-setting.service';
import { WINDOW } from '@qsp-ui-library/tokens/window.token';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import {
  EQimaButtonIconStyle,
  EQimaPosition,
  QimaAvatarFakeModule,
  QimaAvatarModule,
  QimaButtonIconModule,
  QimaButtonModule,
  QimaDividerModule,
  QimaIconModule,
  QimaInputTextModule,
  QimaTooltipDirectiveModule,
} from '@qima/ngx-qima';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    QimaButtonIconModule,
    QimaTooltipDirectiveModule,
    QimaIconModule,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    AccountMenuComponent,
    QimaDividerModule,
    HttpClientModule,
    CommonModule,
    QimaInputTextModule,
    QimaButtonModule,
    TranslateModule,
    QimaAvatarModule,
    QimaAvatarFakeModule,
    TranslateMenuModule,
  ],
})
export class HeaderComponent implements OnInit {
  public currentUser: IUser | undefined = undefined;
  public companyLogo: string = '';
  public qimaLogo = LOCAL_IMAGES.qimalabsLogo;
  public isProfileMenuVisible: boolean = false;
  public isTranslateMenuVisible: boolean = false;
  public managerAvatar: string = '';
  public tooltipPosition: EQimaPosition.RIGHT = EQimaPosition.RIGHT;
  public tooltipMessage: string = 'APP_ASIDE.ASIDE_MENU.EXPAND_PANEL';
  public translateMenuStyle = EQimaButtonIconStyle.TERTIARY;
  public isUserGuideVisible: boolean = !this._appUserSettingService.getIsQimaProduce();

  //
  public constructor(
    @Inject(WINDOW) private readonly _window: IMyWindow,
    private readonly _headerService: HeaderService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _appAuthenticationService: AppAuthenticationService,
    private readonly _dialog: DialogService,
    private readonly _asideService: AsideService,
    private readonly _appUserSettingService: AppUserSettingService,
    private readonly _router: Router,
    public readonly qimaAvatar: QimaAvatarService,
    public readonly qimaIcon: QimaIconService,
    public readonly qimaDivider: QimaDividerService,
    public readonly qimaButton: QimaButtonService,
    public readonly qimaTooltip: QimaTooltipService,
    public readonly qimaButtonIcon: QimaButtonIconService
  ) {}

  //
  public ngOnInit(): void {
    this._getUserInfo();
    this.watch();
  }

  //
  public watch(): void {
    this._appAuthenticationService.currentUserSubject$.pipe(untilDestroyed(this)).subscribe((data: Readonly<IUser>): void => {
      this.currentUser = data;
      this._getUserInfo();
      this._changeDetectorRef.markForCheck();
    });
    //
    this._headerService.isProfileMenuVisible$.pipe(untilDestroyed(this)).subscribe((isProfileMenuVisible: boolean): void => {
      this.isProfileMenuVisible = isProfileMenuVisible;

      this._changeDetectorRef.markForCheck();
    });

    this._headerService.isTranslateMenuVisible$.pipe(untilDestroyed(this)).subscribe((isTranslateMenuVisible: boolean): void => {
      this.isTranslateMenuVisible = isTranslateMenuVisible;
      this.translateMenuStyle = this.isTranslateMenuVisible ? EQimaButtonIconStyle.SECONDARY : EQimaButtonIconStyle.TERTIARY_UTILITY;
    });

    this._headerService.companyLogo$.pipe(untilDestroyed(this)).subscribe((logo: string): void => {
      this.companyLogo = logo;
      this._changeDetectorRef.markForCheck();
    });
    //
    this._asideService.isAsideCollapsed$.pipe(untilDestroyed(this)).subscribe((isCollapsed: Readonly<boolean>): void => {
      this.tooltipMessage = isCollapsed ? 'APP_ASIDE.ASIDE_MENU.EXPAND_PANEL' : 'APP_ASIDE.ASIDE_MENU.COLLAPSE_PANEL';
    });
    //
    //   // this._acaMessageService
    //   //   .companyLogoChange$()
    //   //   .pipe(untilDestroyed(this))
    //   //   .subscribe((): void => this._getCompanyLogo());
  }

  //
  public openUserGuide(): void {
    this._dialog.open(UserGuideComponent);
  }

  public openInstructions(): void {
    this._window.open('https://timer-stitch-70801899.figma.site', '_blank');
  }

  //
  public openTranslate(event: Readonly<MouseEvent | Event>): void {
    event.stopPropagation();
    this.isTranslateMenuVisible = true;
    this.translateMenuStyle = EQimaButtonIconStyle.SECONDARY;
  }

  public onMenuClick(): void {
    this._asideService.onCollapseMenuClick();
  }

  public onQimaLogoClick(): void {
    void this._router.navigateByUrl(`/${ERouters.REPORT_PREPARATION}`);
  }

  public onTranslateOverlayOutsideClick(): void {
    this.isTranslateMenuVisible = false;
    this.translateMenuStyle = EQimaButtonIconStyle.TERTIARY_UTILITY;
  }

  public openProfile(event: Readonly<MouseEvent | Event>): void {
    event.stopPropagation();
    this.isProfileMenuVisible = true;

    this._changeDetectorRef.markForCheck();
  }

  public onProfileOverlayOutsideClick(): void {
    this.isProfileMenuVisible = false;

    this._changeDetectorRef.markForCheck();
  }

  public onProfileOverlayDetach(): void {
    this.isProfileMenuVisible = false;

    this._changeDetectorRef.markForCheck();
  }

  public onTranslateOverlayDetach(): void {
    this.isTranslateMenuVisible = false;

    this._changeDetectorRef.markForCheck();
  }

  private _getUserInfo(): void {
    if (this._appAuthenticationService.isAuthenticated()) {
      this.currentUser = this._appAuthenticationService.getCurrentUser();
    }
  }
}
